<template>
  <!-- <div class="cmp-booking-booking-booking_sidewindow-event_details_artists dbox" :v-if="booking.artists"> -->
  <DBox
    :id="'cmp-booking-booking-booking_sidewindow-event_details_artists'"
    :addButton="false"
    :addLink="false"
    :addLinkLabel="`${$t('add_new')} ${$t('artist')}`"
    @add_click="addArtistClick"
  >
    <NTable
      v-if="booking.artists && booking.artists.length > 0"
      class="artist-list dbox1"
      :headers="eventDetailsArtistsHeaders"
      :id="'booking-booking-booking_sidewindow-event_details_artists'"
      :items="booking.artists"
      :config="tableConfig"
    >
      <!-- bb="none" -->
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td
            v-bind="tdcon('artist')"
            class="artist"
            @click="(e) => onArtistNameClick(item)"
          >
            <div>
              {{ item["artist_name"] }}
            </div>
          </td>
          <td v-bind="tdcon('performance_type')">
            <TextField2
              type="text"
              class="dbox1"
              id="performance_type"
              :showLabel="false"
              :disabled="false"
              :placeholder="$t('performance')"
              :value="item['performance_type']"
              :bb="'0px'"
              @change="(e) => onTextFieldChange(e, item)"
            />
            <!-- <input
              type="text"
              class="ntable--textfield"
              name="performance_type"
              id="performance_type"
              placeholder="Performance Type..."
              :value="item['performance_type']"
              v-on:blur="e => onTextInputBlur(e, 'performance_type', item)"
            /> -->
          </td>
          <td v-bind="tdcon('soundcheck')">
            <TextField2
              type="text"
              class="dbox1"
              id="soundcheck"
              :showLabel="false"
              :disabled="false"
              :placeholder="$t('type_in_time')"
              :value="item['soundcheck']"
              :bb="'0px'"
              @change="(e) => onTextFieldChange(e, item)"
            />
            <!-- <input
              type="text"
              class="ntable--textfield"
              name="soundcheck"
              id="soundcheck"
              placeholder="Soundcheck..."
              :value="item['soundcheck']"
              v-on:blur="e => onTextInputBlur(e, 'soundcheck', item)"
            /> -->
          </td>
          <td v-bind="tdcon('stage_time')">
            <TextField2
              type="text"
              class="dbox1"
              id="performance_time"
              :showLabel="false"
              :disabled="false"
              :placeholder="$t('performance_time_string')"
              :value="item['performance_time']"
              :bb="'0px'"
              @change="(e) => onTextFieldChange(e, item)"
            />
            <!-- <input
              type="text"
              class="ntable--textfield"
              name="stage_time"
              id="stage_time"
              placeholder="Performance Time..."
              :value="item['performance_time']"
              v-on:blur="e => onTextInputBlur(e, 'performance_time', item)"
            /> -->
          </td>
          <td v-bind="tdcon('duration')">
            <TextField2
              type="text"
              class="dbox1"
              id="performance_time_contract"
              :showLabel="false"
              :disabled="false"
              :placeholder="$t('performance_duration')"
              :value="transformTime(item['performance_time_contract'])"
              :bb="'0px'"
              @change="(e) => onTextFieldChange(e, item)"
            />
            <!-- <input
              type="text"
              class="ntable--textfield"
              name="duration"
              id="duration"
              placeholder="Performance Duration..."
              :value="item['performance_time_contract']"
              v-on:blur="e => onTextInputBlur(e, 'performance_time_contract', item)"
            /> -->
          </td>
          <td v-bind="tdcon('stage_name')">
            <TextField2
              type="text"
              class="dbox1"
              id="stage_name"
              :showLabel="false"
              :disabled="false"
              :placeholder="$t('stage_name_string')"
              :value="item['stage_name']"
              :bb="'0px'"
              @change="(e) => onTextFieldChange(e, item)"
            />
            <!-- <input
              type="text"
              class="ntable--textfield"
              name="stage_name"
              id="stage_name"
              placeholder="Stage Name..."
              :value="item['stage_name']"
              v-on:blur="e => onTextInputBlur(e, 'stage_name', item)"
            /> -->
          </td>
          <td
            v-bind="tdcon('close')"
            style="display: flex; flex-direction: row"
          >
            <div class="dt-checkbox v2 s1" style="margin: auto 10px">
              <input
                type="checkbox"
                name="checkbox"
                id="checkbox"
                :checked="
                  lockJson &&
                  lockJson[
                    `calendar_date_artists_${item['calendar_date_artist_id']}`
                  ] == 'lock'
                    ? true
                    : false
                "
                @click="(e) => onCheckboxChange(e, 'confirmed_flag', item)"
              />
              <div class="checkmark"></div>
            </div>
            <img
              style="width: 30px; margin-right: 5px"
              :src="
                lockJson[
                  `calendar_date_artists_${item['calendar_date_artist_id']}`
                ] == 'lock'
                  ? 'static/icons/booking/lock-closed.svg'
                  : 'static/icons/booking/lock-open.svg'
              "
              class="dt-icon"
              :alt="$t('lock_status_in_questionnaire')"
              :title="$t('lock_status_in_questionnaire')"
            />
          </td>
        </tr>
      </template>
    </NTable>
    <!-- <div class="dbox-title-bar--options">
      <img @click="addArtistClick" src="static/icons/add-icon.svg" class="dt-icon v4" alt /> -->
    <!-- <div class="button">
              <div class="dt-icon-container">
                <img @click="addArtistClick" src="static/icons/add.svg" class="dt-icon" alt="">
              </div>
      </div>-->
    <!-- </div>
  </div> -->
  </DBox>
</template>

<script>
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
import NTable from "@/plugins/datatable/datatable";

export default {
  components: {
    NTable,
  },
  props: ["booking", "lockJson"],
  data: function () {
    return {
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
        footer: false,
      }),
    };
  },
  computed: {
    eventDetailsArtistsHeaders: function () {
      return [
        createTableHeader("artist"),
        createTableHeader("performance_type", { text: "type" }),
        createTableHeader("soundcheck", { text: "soundcheck" }),
        createTableHeader("stage_time", { text: "time" }),
        createTableHeader("duration", { text: "duration" }),
        createTableHeader("stage_name", { text: "stage" }),
        createTableHeader("close", {
          text: "confirmed",
          mw: 90,
          ta: "left",
        }),
      ];
    },
  },
  methods: {
    transformTime(value) {
      if (value) {
        if (value > 60) {
          return `${parseInt(value / 60)} hour`;
        } else {
          return `${value}`;
        }
      }
    },
    onTextFieldChange: function (e, item) {
      //const value = event.target.value;
      this.$emit("updated", {
        item,
        name: e.name,
        value: e.value,
      });
    },
    onTextInputBlur: function (event, name, item) {
      const value = event.target.value;
      this.$emit("updated", {
        item,
        name,
        value,
      });
    },
    onCheckboxChange: function (event, name, item) {
      const checked = event.target.checked;
      const value = checked === true ? "1" : "0";

      this.$emit("updated", {
        item,
        name,
        value,
      });
    },
    onArtistNameClick: function (artist) {
      this.$emit(
        "artist_calendar_date_selected",
        artist.calendar_date_artist_id
      );
    },
    addArtistClick: function () {
      this.$router.push({
        ...this.$route,
        query: { ...this.$route.query, modal: "add_artist_to_booking" },
      });
    },
  },
};
</script>

<style lang="scss">
.cmp-booking-booking-booking_sidewindow-event_details_artists {
  // height: 100%;
  // display: flex;
  .dt-ntable {
    /* --ntable-height:167px; */
  }
}
</style>
